document.addEventListener('DOMContentLoaded', () => {
  const topbarElement = document.querySelector('.topbar');
  const headerElement = document.querySelector('.header');
  const bodyElement = document.querySelector('body');

  if (topbarElement && headerElement) {
    if (!headerElement.classList.contains('extendedHeader')) {
      headerElement.classList.add('extendedHeader');
    }
    if (!bodyElement.classList.contains('extendedHeader')) {
      bodyElement.classList.add('extendedHeader');
    }
  } else {
    console.warn('Topbar or header element not found.');
  }
});